<template>
  <div v-cloak id="test" class="navBar">
    <!-- 顶部导航 -->
    <div class="header top">
      <div class="con-wrap">
        <a
          class="logo"
          href="//www.leiting.com/mobile/index.html"
        >雷霆游戏
          <img
            src="//static.leiting.com/images/common/lt_logo_dark.png"
            alt=""
          ></a>
        <div class="jumpTitle">
          <p @click="jumpLink('3')">账号自助管理</p>
          <p @click="jumpLink('2')">账号中心</p>
        </div>
        <div class="op-wrap">
          <a
            id="menu_btn"
            class="btn-menu"
            href="javascript:;"
            role="button"
            @click="menu"
          >
            <i class="line" />
            <i class="line" />
            <i class="line" />
          </a>
        </div>
      </div>
      <div id="menu_modal" class="menu-wrap">
        <ul v-if="isHomeBar" class="list">
          <li class="item">
            <a
              class="txt"
              href="//www.leiting.com/mobile/index.html"
            ><span>首页</span></a>
          </li>
          <li class="item">
            <a class="txt" @click="jumpLink('1')"><span>账号注册</span></a>
          </li>
          <li class="item">
            <a class="txt" @click="jumpLink('2')"><span>账号中心</span></a>
          </li>
          <li class="item">
            <a class="txt" @click="jumpLink('3')"><span>账号自助管理</span></a>
          </li>
        </ul>
        <ul class="list">
          <li class="item">
            <a
              class="txt"
              @click="jumpPage('accountInfo')"
            ><span>账号信息</span></a>
          </li>
          <li class="item">
            <a
              class="txt"
              @click="jumpPage('editPhoneNum')"
            ><span>修改密码</span></a>
          </li>
          <li class="item">
            <a
              class="txt"
              @click="jumpPage('identityAuth')"
            ><span>身份认证</span></a>
          </li>
          <li class="item">
            <a
              class="txt"
              @click="jumpPage('phoneManage')"
            ><span>手机号管理</span></a>
          </li>
          <li class="item">
            <a
              class="txt"
              @click="jumpPage('logoutAccount')"
            ><span>账号/单手游注销</span></a>
          </li>
          <li class="item">
            <a
              class="txt"
              @click="jumpPage('accountSecurity')"
            ><span>账号安全</span></a>
          </li>
          <li class="item">
            <a class="txt" @click="logout()"><span>退出</span></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/account-center-manage/accountInfo'
export default {
  name: 'CommonNavBar',
  components: {},
  props: {
    isHomeBar: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      mHeight: null,
      http: window.location.href,
      currentIndex: 1,
      showTagList: []
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    logout() {
      this.$pubConfirm('确定要退出吗？', () => {
        api.logout().then((res) => {
          if (res.status == 0) {
            // 未登录
            this.$store.dispatch('authLogin/saveIslogin', '0')
            setTimeout(() => {
              window.ltlAccount.logout()
            })
            // this.$router.go(0)
          }
        })
      })
    },
    jumpLink(type) {
      if (type == '1') {
        this.$router.push('/accountCenter/register')
      } else if (type == '2') {
        this.$router.push('/accountCenter/accountList/accountInfo')
      } else {
        this.$router.push('/accountCenter/index')
      }
      const t = document.getElementById('menu_btn')
      const d = document.getElementById('menu_modal')
      if (t.classList.contains('active')) {
        t.classList.remove('active')
        d.classList.remove('active')
      }
    },
    jumpPage(type) {
      if (type == 'editPhoneNum') {
        this.$router.push(
          '/accountCenter/accountList/editPhoneNum?type=PWD_MODIFY'
        )
      } else {
        this.$router.push('/accountCenter/accountList/' + type)
      }
      this.menu()
    },
    // 类型追加
    menu() {
      const t = document.getElementById('menu_btn')
      const d = document.getElementById('menu_modal')
      if (t.classList.contains('active')) {
        t.classList.remove('active')
        d.classList.remove('active')
      } else {
        t.classList.add('active')
        d.classList.add('active')
      }
    }
  }
}
</script>
<style lang="stylus">
@import '~assets/css/reset.styl';
</style>

<style lang="stylus" scoped>
.navBar {
  z-index: 999;
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 750px
  .item {
    .txt {
      font-weight: 400;
    }
  }
}

.con-wrap .logo {
  width: auto;
  height: auto;

  img {
    width: 1.58rem;
    height: 0.62rem;
    display: block;
  }
}

body {
  .jumpTitle {
    display: flex;
    align-items: center;
    height: 100%;

    p {
      font-size: 0.26rem;
      color: #7C7C7C;
      margin-right: 0.4rem;
    }
  }

  .content {
    @media (min-width: 850px) {
      padding: 0 20% 0;
    }
  }

  max-width: 100%;

  .header .menu-wrap .list .item {
    min-height: 1.3rem;
    flex: none;
  }

  .active {
    // border-bottom: 3px #606de2 solid;
    font-size: 0.4rem;
    color: black !important;
    font-weight: bold;
  }

  .title {
    position: absolute;
    width: 10rem;
    height: 100%;
    left: 40%;
    display: flex;

    p {
      flex: 1;
      color: #5d5d5d;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.36rem;
      cursor: pointer;
    }
  }
}
</style>
